<div style="padding:30px">

    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item" (click)="choosetag(item.id)">
            <span style="cursor:pointer"  [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>


    <div *ngIf="now=='0'" style="margin-left:10px ;">

        <input (keyup.enter)="init_list()" type="text" [(ngModel)]="search_model" style="width: 160px;display:inline-block" class="form-control" placeholder="請輸入姓名或手機">
        <button class="btn btn-primary"  (click)="init_list()">確認</button>
        <app-table-v2  *ngIf="data.length>0" [type]="2" [tcontent]="tcontent" [data]="data">
            <ng-template let-post #operation_dk>

                <div *ngIf="post.key == 'os_type' && power*1>=3">
                    {{post.val.os_type?(post.val.os_type==1?'Android':'iOS'):'無填寫'}}
                </div>
                <div *ngIf="post.key == 'gg' && power * 1 >= 3 && post.val.is_enable * 1 == 0">
                    <button (click)="loadUserBlackHistory(post.val)" type="button" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-xl">
                        點我設定
                    </button>
                </div>
                <div *ngIf="post.key == 'gg' && power * 1 >= 3 && post.val.is_enable * 1 == 2">
                    申請復權中
                </div>
            </ng-template>
        </app-table-v2>

        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
        <div *ngIf="data.length==0">無資料</div>

    </div>

    <div *ngIf="now=='1'" style="margin-left:10px ;">

        <input (keyup.enter)="black_list()" type="text" [(ngModel)]="search_model" style="width: 160px;display:inline-block" class="form-control" placeholder="請輸入姓名">
        <button class="btn btn-primary"  (click)="black_list()" style="margin-right: 40px;">確認</button>

        狀態篩選
        <select class="form-control" style="width: 160px;display: inline-block;" [(ngModel)]="punish_status" (change)="pageobj.page=0;black_list()">
            <option *ngFor="let item of punish_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <app-table-v2  *ngIf="data.length>0" [type]="2" [tcontent]="tcontent" [data]="data" (sortdata)="handlesortdata($event)">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'status'">
                    {{punish_obj[post.val.status]}}
                </div>

                <div *ngIf="post.key == 'Nogood'">
                    <button (click)="clicklink(post.val.uid)" type="button" class="btn btn-success">
                      點我查看
                    </button>
                </div>
                <div *ngIf="post.key == 'gg'">
                    <button (click)="edit_data=post.val;msg=''" type="button" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-xl">
                      點我設定
                    </button>
                </div>
            </ng-template>
        </app-table-v2>
        <app-pagnation (callback)="callback2($event)" [data]="pageobjstr"></app-pagnation>
        <div *ngIf="data.length==0">無資料</div>
    </div>

</div>

<div
*ngIf="edit_data && now=='0'"
class="modal fade bd-example-modal-xl" tabindex="-1"
role="dialog"  data-keyboard="false" data-backdrop="static"
aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
>
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
            <h5 class="modal-title">操作與歷史</h5>
            <button (click)="init_list();" type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
          <div class="user_edit_block d-flex align-items-center">
            <span class="h5"><strong> 🔰 暱稱 : {{edit_data.name}}( {{edit_data.uid}} ) </strong></span>

          </div>
          <div class="user_edit_block d-flex align-items-center">
            <span class="h5"><strong>📱 電話 : {{edit_data.phone_num}} </strong></span>
          </div>
          <div class="user_edit_block d-flex align-items-center" style="display: flex;">
                <span class="h6"><strong>🎛️ 帳號使用狀態</strong></span>

                <app-check-permissions [data]="'VbpG'">
                    <button [ngClass]="edit_data.is_enable == 2 ? 'btn-danger' : 'btn-secondary'" (click)="edit_data.is_enable=2" class="btn" style="margin-right: 5px;margin-left: 5px;">復權</button>
                </app-check-permissions>
                <app-check-permissions [data]="'xEkH'">
                    <button [ngClass]="edit_data.is_enable == 1 ? 'btn-danger' : 'btn-secondary'" (click)="edit_data.is_enable=1" class="btn" style="margin-right: 5px;margin-left: 5px;">解除封鎖</button>
                </app-check-permissions>
                <input *ngIf="edit_data.is_enable == 1"
                    type="text" [(ngModel)]="edit_data.unblock_reason"
                    class="form-control fix_input" placeholder="請輸入解除封鎖原因">
                <div style="margin-left: 15px;">
                    <button [ngClass]="edit_data.is_enable == -1 ? 'btn-danger' : 'btn-secondary'"  (click)="edit_data.is_enable=-1" class="btn" style="margin-right: 5px;">封鎖使用者手機號碼</button>
                    <!-- <button [ngClass]="edit_data.is_enable == 0 ? 'btn-danger' : 'btn-secondary'"  (click)="edit_data.is_enable=0" class="btn" style="margin-right: 5px;" >停權</button> -->
                </div>

                <!-- <input *ngIf="edit_data.is_enable == 0 || edit_data.is_enable == -1" type="text" [(ngModel)]="edit_data.block_reason" class="form-control fix_input"  placeholder="停權原因" > -->
                <!-- <input *ngIf=" edit_data.is_enable == 2" type="text" [(ngModel)]="edit_data.block_reason" class="form-control fix_input"  placeholder="復權原因" > -->
                <!-- 當選擇「正常」(edit_data.is_enable == 1) 時，顯示輸入框 -->

          </div>
          <hr>
          <!-- 新增黑名單歷史表格 -->
            <div *ngIf="edit_data.history && edit_data.history.length > 0" class="user_edit_block">
                <h5>📋封鎖 / 解鎖歷史紀錄</h5>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>操作</th>
                            <th>原因</th>
                            <th>管理員</th>
                            <th>時間</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let record of historyData; let i = index" [ngClass]="{'table-danger': record.action == 1, 'table-success': record.action == 0}">
                            <td>{{ i + 1 }}</td>
                            <td>{{ record.action == 1 ? '封鎖' : '解鎖' }}</td>
                            <td>{{ record.reason || '無原因' }}</td>
                            <td>{{ record.admin_name || '未知' }}</td>
                            <td>{{ record.create_dt }}</td>
                        </tr>
                    </tbody>
                </table>

                <!-- 分頁組件 -->
                <app-pagnation (callback)="historyCallback($event)" [data]="historyPageObjStr"></app-pagnation>
            </div>


        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
            <button type="button"  (click)="save()"  class="btn btn-primary">確認</button>
            <button id="ModalClose" type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
        </div>
        </div>
    </div>
</div>

<div
*ngIf="edit_data && now=='1'"
class="modal fade bd-example-modal-xl" tabindex="-1"
role="dialog"  data-keyboard="false" data-backdrop="static"
aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
>
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
            <h5 class="modal-title">懲處清單操作</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
            <div class="user_edit_block form-group">
                <label class="col-sm-2 col-form-label">暱稱</label>
                {{edit_data.name}}( {{edit_data.uid}} )
            </div>
            <div class="user_edit_block form-group">
                <label class="col-sm-2 col-form-label">懲罰時間</label>
                <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.bang_time">
            </div>
            <div class="user_edit_block form-group">
                <button type="button"  (click)="clickpunsh()"  class="btn btn-success" style="margin-bottom: 10px;">懲罰清空</button>
            </div>

        <!-- Modal footer -->
        <div class="modal-footer">
            <button type="button"  (click)="savepunsh()"  class="btn btn-primary">確認</button>
            <button id="ModalClose" type="button" (click)="black_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
        </div>
        </div>
    </div>
</div>

<app-spinner [loading]="loading"></app-spinner>
